import React from 'react';
import CustomButton from '../customButton';
import Card from 'react-bootstrap/Card';
// import { Link } from 'react-router-dom';
import bigCardCSS from './bigCard.module.css';

export function BigCard({ p1, p2, p3,  p_className, buttonTitle, buttonClass, cardClass, buttonOnClick }) {
 
    return(
        <div>
            <Card className={bigCardCSS.bigCard}>
                <CustomButton 
                    label={buttonTitle}
                    className={buttonClass}
                    onClick={buttonOnClick}
                />
                <Card.Body>
                    <p className={p_className}>- {p1}</p>
                    <p className={p_className}>- {p2}</p>
                    <p className={p_className}>- {p3}</p>
                </Card.Body>
            </Card>
        </div>
    )
}

export default BigCard;